export default __webpack_public_path__ + "static/media/tick_mark.ad27d98d.svg";